import { useState } from 'react';
import { deserializeScenario } from './utilizationLogic';

// Months moved by each arrow click: follows the grouping, so Quarter view steps a quarter.
export const STEP = { month: 1, quarter: 3, year: 12 };
export const TODAY_START = 12; // the planner feed begins 12 months before today

/**
 * Filters and view settings shared by the Capacity and Utilization tabs (lifted to ResourcePlanning so
 * flipping between them keeps the same teams, grouping, window, scenario and Hours/Revenue choice).
 */
export function usePlannerState() {
  const [grain, setGrain] = useState('month');
  const [teamIds, setTeamIds] = useState([]);
  const [includePipeline, setIncludePipeline] = useState(true);
  const [windowMonths, setWindowMonths] = useState(12);
  const [start, setStart] = useState(TODAY_START);
  const [scenarios, setScenarios] = useState({});
  const [savedId, setSavedId] = useState('');
  const pickScenario = (id, saved) => {
    setSavedId(id);
    const v = saved.find((x) => x.id === id);
    setScenarios(v ? deserializeScenario(v.config) : {});
  };
  const earlier = () => setStart((x) => Math.max(0, x - STEP[grain]));
  const later = (feedLen) => setStart((x) => Math.min(Math.max(0, feedLen - windowMonths), x + STEP[grain]));
  return {
    grain, setGrain, teamIds, setTeamIds, includePipeline, setIncludePipeline, windowMonths, setWindowMonths,
    start, setStart, scenarios, setScenarios, savedId, setSavedId, pickScenario, earlier, later,
  };
}
